// Page-local reimplementation of the macro substitution the legacy advertising textlinks package
// does. That package is publishable and off-limits here, and deep-importing its lib/ would depend
// on its package.json lacking an `exports` field.
const MACRO_REGEXP = /\$\$[a-zA-Z0-9_\-.]+\$\$/g
const MACRO_DELIMITER_REGEXP = /\$\$/g
const DATALAYER_MACRO = 'DATALAYER_PARAMS'

const DATALAYER_KEYWORDS = [
  'ad_publisher_type_id',
  'brand',
  'brand_id',
  'car_body',
  'city',
  'fuel',
  'km',
  'model',
  'model_id',
  'mts2',
  'power',
  'price',
  'property_id',
  'property_state_id',
  'property_sub_id',
  'region_level2',
  'rooms',
  'transaction_id',
  'transmission_id',
  'urlp',
  'version',
  'year'
]

const dataLayerQueryParams = ({pageData}) =>
  DATALAYER_KEYWORDS.filter(key => Boolean(pageData[key]))
    .map(key => `${key}=${encodeURI(pageData[key])}`)
    .join('&')

// The macro is the whole query string, so stripping it leaves a complete, navigable URL that
// only loses analytics params — which is what the href is seeded with server-side.
export const stripClickUrlMacros = clickUrl => clickUrl?.replace(MACRO_REGEXP, '') ?? clickUrl

export const clickUrlTransformationService = ({clickUrl, pageData}) => {
  if (!clickUrl || !pageData) return clickUrl

  const macros = clickUrl.match(MACRO_REGEXP)
  if (!macros) return clickUrl

  return macros.reduce((url, macro) => {
    const key = macro.replace(MACRO_DELIMITER_REGEXP, '')
    const value = key === DATALAYER_MACRO ? dataLayerQueryParams({pageData}) : encodeURI(pageData[key] ?? '')
    return url.replace(macro, value)
  }, clickUrl)
}
